var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedium = function SvgMedium(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM3.79705 5.078C3.89482 5.16819 3.94476 5.30064 3.9315 5.43465V10.2597C3.96051 10.4337 3.9069 10.6115 3.78709 10.7386L2.66664 12.1295V12.313H5.84373V12.1295L4.72329 10.7386C4.60259 10.6117 4.54566 10.4351 4.56891 10.2597V6.08681L7.35758 12.313H7.68127L10.0765 6.08681V11.0494C10.0765 11.1819 10.0765 11.2073 9.99188 11.2939L9.13038 12.1499V12.3333H13.3134V12.1499L12.4818 11.3143C12.4084 11.2571 12.3719 11.1629 12.3872 11.0698V4.93024C12.3719 4.83708 12.4084 4.74295 12.4818 4.68568L13.3333 3.85009V3.66667H10.3853L8.28382 9.03175L5.89353 3.66667H2.8011V3.85009L3.79705 5.078Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Medium.d852cdcb.svg";
export { ForwardRef as ReactComponent };